export default "__VITE_ASSET__DjsFYtRo__"